import styled from "styled-components";
import { Checkbox } from "@vds/checkboxes";

export const HeaderDivUsrGrpDet = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 768px) {
    gap: 24px;
  }

  @media (min-width: 1400px) {
    gap: 31px;
  }
`;
export const GrpNameAndSearchDiv = styled.div`
  width: 100%;
  max-height: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 26px;
    max-height: 36px;
  }
`;

export const UsrGrpTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.3;
  max-width: 100%;

  @media (min-width: 768px) {
    font-size: 24px;
    word-break: normal;
    hyphens: none;
  }
`;

export const SiteNameInputAndButtonsDiv = styled.div`
  width: 100%;
  max-height: none;
  margin-top: 28px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    max-height: 64px;
  }
`;

export const ButtonGroupWrapper = styled.div`
  margin-left: 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-shrink: 0;
  gap: 8px;

  @media (min-width: 768px) and (max-width: 1023px) {
    margin-left: 10px;
    width: fit-content;
    justify-content: flex-end;
  }

  @media (min-width: 1024px) {
    margin-left: 10px;
    width: fit-content;
    justify-content: flex-end;
  }
`;

export const InlineCheckbox = styled(Checkbox)`
  display: inline-block;
`;

// Invite User Modal responsive styles
export const ModalInputContainer = styled.div`
  margin-bottom: 30px;
  width: 100%;

  /* Target VDS input wrapper with higher specificity */
  & .vds-input,
  & .vds-input-wrapper,
  & input[class*="vds"] {
    width: 100%;
    max-width: 100%;
  }

  @media (min-width: 768px) {
    & .vds-input,
    & .vds-input-wrapper,
    & input[class*="vds"] {
      width: 300px;
      max-width: 300px;
    }
  }
`;

// Variant with top margin for first input in a section
export const ModalInputContainerFirst = styled(ModalInputContainer)`
  margin-top: 30px;
`;

export const ModalDropdownContainer = styled.div`
  margin-top: 30px;
  width: 100%;

  @media (min-width: 768px) {
    width: 66%;
  }
`;

export const ModalNotificationContainer = styled.div`
  margin-bottom: 70px;
  width: 100%;
  max-width: 100%;

  /* Target VDS notification with higher specificity */
  & .vds-notification,
  & [class*="vds-notification"] {
    width: 100%;
    max-width: 100%;
  }

  @media (min-width: 768px) {
    width: 464px;
    max-width: 464px;

    & .vds-notification,
    & [class*="vds-notification"] {
      width: 464px;
      max-width: 464px;
    }
  }
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 1px;
  gap: 8px;

  button {
    width: 48%;
  }
`;

// Variant with bottom margin (5%) for modal button group
export const ModalButtonGroupWithMargin = styled(ModalButtonGroup)`
  margin-bottom: 5%;
`;

// Variant with top and bottom margin for modal button group
export const ModalButtonGroupWithTopMargin = styled(ModalButtonGroup)`
  margin-top: 35px;
  margin-bottom: 5%;
`;

// Variant with bottom margin and custom gap for modal button group
export const ModalButtonGroupWithGap = styled(ModalButtonGroup)`
  margin-bottom: 5%;
  gap: 12px;

  button {
    border-radius: 24px;
  }
`;

// Step 2 — billing accounts list
export const BillingAccountsListWrapper = styled.div`
  margin-bottom: 30px;
  overflow-y: auto;
  max-height: 290px;
`;

export const BillingAccountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 6px;
  border-bottom: 1px solid #e6e6e6;
  cursor: pointer;
`;

export const BillingAccountCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// Step 4 — assign user to site
export const AssignSiteStickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
`;

export const AssignSiteStickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
`;

export const AssignSiteIntroWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const SiteSearchWrapper = styled.div`
  margin-bottom: 8px;

  & .ant-input-affix-wrapper {
    padding-left: 4px;
  }
`;

export const SitesScrollWrapper = styled.div`
  margin-bottom: 16px;
  overflow-y: auto;
  max-height: 240px;
`;

export const SiteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 4px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
`;

export const SiteRowLabelWrapper = styled.div`
  margin-left: 12px;
  display: flex;
  flex-direction: column;
`;

export const SiteRowName = styled.span`
  font-size: 15px;
  font-weight: 400;
`;
